import HeroSlider from '../sections/HeroSlider';
import Lineup from '../sections/Lineup';
import Marquee from '../components/Marquee';
import VoteSection from '../sections/VoteSection';
import RangeWheel from '../sections/RangeWheel';
import MoodArch from '../sections/MoodArch';
import PromoTiles from '../sections/PromoTiles';
import SnackedToday from '../sections/SnackedToday';
import Footer from '../sections/Footer';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <HeroSlider />
      <Marquee dark text="15G PROTEIN · ROASTED & PLANT BASED · NO PALM OIL · NO ARTIFICIAL COLOURS · MULTIGRAIN ·" />
      <Lineup />
      <VoteSection compact />
      <RangeWheel />
      <MoodArch />
      <Marquee reverse text="WARNING : MAY CAUSE AN IRRESISTIBLE URGE TO GO BEYOND ·" testid="marquee-light" />
      <PromoTiles />
      <SnackedToday />
      <Footer />
    </main>
  );
}
